import { RxBookmark } from '@react-icons/all-files/rx/RxBookmark'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import type { GROUP_TYPE } from '@disco/constants/GroupTypes'
import { INBOX_TYPES } from '@disco/constants/GroupTypes'
import { sendMixpanelEvent } from '@disco/state-management/actions/AnalyticsActions'
import { insertPlaylist } from '@disco/state-management/actions/ShortlistActions'
import { getShortlists } from '@disco/state-management/selectors/shortlists'
import { sendPlaylistDownloadEventThrottled } from '@disco/utils/eventsApi'

import type { Playlist } from 'types/playlist'

import { DropdownMenu, Flex } from 'components/ds'

import { useDispatch, useSelector } from 'hooks/use-redux'

type Props = {
  playlist: Playlist
  sourceGroupId: number | null
  sourceGroupType: GROUP_TYPE | null
}

const AddToShortlist = ({
  playlist,
  sourceGroupId,
  sourceGroupType,
}: Props): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const shortlists = useSelector(getShortlists)

  const insertAndClose = () => {
    dispatch(insertPlaylist(shortlists[0].id, { playlist }))

    if (sourceGroupType && INBOX_TYPES.includes(sourceGroupType)) {
      sendPlaylistDownloadEventThrottled(
        playlist.playlist_id,
        undefined,
        sourceGroupId,
      )
    }

    dispatch(
      sendMixpanelEvent('Add playlist to shortlist via add to shortlist'),
    )
  }

  const label = (
    <Flex align="center" gap="2">
      <RxBookmark />
      Add to Playlist Creator
    </Flex>
  )

  if (shortlists.length === 1) {
    return (
      <DropdownMenu.Item onSelect={insertAndClose}>{label}</DropdownMenu.Item>
    )
  }

  const playlistId = playlist.playlist_id
  return (
    <DropdownMenu.Item
      onSelect={() =>
        navigate(
          `/explorer/playlists/${playlistId}/add-to-shortlist${
            sourceGroupId ? `?group=${sourceGroupId}` : ''
          }`,
        )
      }
    >
      {label}
    </DropdownMenu.Item>
  )
}

export default AddToShortlist
